(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community-rich-text"] && !Shopify.designMode) return;
  try {
    
  $(function() {
    $('.rich-text__buttons_community .button').click(function() {
        $('.Image_upload_form').addClass("active");
    });
  }); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor(){super();}
  connectedCallback(){
    this.header=document.querySelector('.section-header');
    this.headerIsAlwaysSticky=this.getAttribute('data-sticky-type')==='always'||this.getAttribute('data-sticky-type')==='reduce-logo-size';
    this.setHeaderHeight();
    window.addEventListener('scroll',this.onScroll.bind(this),false);
    this.createObserver();
  }
  setHeaderHeight(){document.documentElement.style.setProperty('--header-height',`${this.header.offsetHeight}px`);}
  createObserver(){let o=new IntersectionObserver((e,o)=>{this.headerBounds=e[0].intersectionRect;o.disconnect();});o.observe(this.header);}
  onScroll(){const s=window.pageYOffset||document.documentElement.scrollTop;
    if(s>this.headerBounds.bottom){this.header.classList.add('shopify-section-header-sticky');}
    else{this.header.classList.remove('shopify-section-header-sticky');}}
}
customElements.define('sticky-header',StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-chart"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const openBtn = document.getElementById('openSizeChart');
  const closeBtn = document.getElementById('closeSizeChart');
  const popup = document.getElementById('sizeChartPopup');

  if (openBtn && popup && closeBtn) {
    openBtn.addEventListener('click', () => popup.style.display = 'flex');
    closeBtn.addEventListener('click', () => popup.style.display = 'none');
    popup.addEventListener('click', e => {
      if (e.target === popup) popup.style.display = 'none';
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
